import { Injectable, inject } from "@angular/core";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";
import { ApplicationType, productStringFromApplicationType } from "@app/views-interfaces";
import { ResponseErrorHandlerService } from "../response-error-handler-service/response-error-handler.service";
import { ITaxReturnStatus } from "../../views-interfaces/tax-return-status-model.interface";

export interface IReturnStatusResponse {
    active: boolean;
    customReturnStatusId: string;
    isPredefined: boolean;
    listOrder: number;
    nameEn: string;
    nameFr: string;
    productType: number;
}
@Injectable({
    providedIn: "root",
})
export class IfirmTaxReturnStatusesService {
    private iframeMessagesService = inject(IframeMessagesService);
    private readonly responseErrorHandlerService = inject(ResponseErrorHandlerService);

    constructor() {}

    async getReturnStatuses(applicationType: ApplicationType): Promise<ITaxReturnStatus[] | undefined> {
        const productType = productStringFromApplicationType(applicationType);
        try {
            const result = await this.iframeMessagesService.postMessageResp("getReturnStatuses", { productType: productType }, "gotReturnStatuses");
            if (result.status === "success") {
                return result.response.map(this.fitResponse);
            }
            this.responseErrorHandlerService.showPopup({
                typeLayout: "ERROR",
                messageCode: "defaultError",
            });
        } catch (error) {
            this.responseErrorHandlerService.showPopup({
                typeLayout: "ERROR",
                messageCode: "defaultError",
            });
        }
    }

    fitResponse(response: IReturnStatusResponse, idx: number | string): ITaxReturnStatus {
        return {
            ReturnStatusKey: "created", // Why?
            Name: {
                "en-CA": response.nameEn,
                "fr-CA": response.nameFr,
            },
            TaxAppStatusId: idx.toString(),
            Id: response.customReturnStatusId,
            Active: response.active,
        };
    }
}
